import { Dialog, Text } from '@prophecy/ui-v3';

import { generateLogoutSigningCertificate } from '../../../../data/apis/api';

const TURN_ON_SLO = 'Turn on Single Logout and save first.';
const CERTIFICATE_FILENAME = 'prophecy-slo-signing.crt';

export const signingTooltipFor = (isSloSaved: boolean, hasCertificate: boolean) =>
  !isSloSaved
    ? TURN_ON_SLO
    : !hasCertificate
      ? 'Generate a certificate before enabling.'
      : 'Signs the single logout messages Prophecy sends to your identity provider.';

export const generateTooltipFor = (isSloSaved: boolean) =>
  isSloSaved
    ? "Creates a new signing certificate and downloads it. Upload it to your identity provider's Signature Certificate field. Generating replaces any existing certificate immediately. Single logout will fail until the new one is uploaded."
    : TURN_ON_SLO;

export const certificateStatusFor = (isSloSaved: boolean, hasCertificate: boolean) =>
  !isSloSaved ? '' : hasCertificate ? 'Certificate generated' : 'No certificate yet';

export const confirmReplaceCertificate = async () =>
  (await Dialog.alert({
    title: 'Replace signing certificate?',
    children: (
      <Text level='sm'>
        The current certificate stops working immediately. Single logout fails until you upload the new one to your
        identity provider.
      </Text>
    ),
    okButton: { danger: true, children: <>Generate</> },
    'data-test-id': 'saml-auth-replace-cert-confirm-dialog'
  })) === Dialog.ResponseAction.okButton;

const downloadCertificate = (certificate: string) => {
  const url = URL.createObjectURL(new Blob([certificate], { type: 'application/x-x509-ca-cert' }));
  const link = document.createElement('a');
  link.href = url;
  link.download = CERTIFICATE_FILENAME;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};

const FAILED = 'Could not generate the signing certificate.';

export async function generateAndDownloadCertificate(connectorId: string): Promise<string | undefined> {
  try {
    // Failures arrive as HTTP 200 with success: false, so branch on the body.
    const resp = await generateLogoutSigningCertificate(connectorId);
    if (!resp?.success || !resp.certificate) return resp?.message || FAILED;

    downloadCertificate(resp.certificate);
    return undefined;
  } catch {
    return FAILED;
  }
}
